var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.step,{tag:"component",attrs:{"account":_vm.account},on:{"change:step":_vm.goto,"complete":_vm.complete}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }